"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function inverseAmount(amount) {
    var value = Number(amount) * -1;
    return value.toFixed(2);
}
exports.inverseAmount = inverseAmount;
function sum(amounts) {
    var sum = amounts.reduce(function (a, b) { return Number(a) + Number(b); }, 0);
    return Number(sum).toFixed(2);
}
exports.sum = sum;
function sumsToZero(amounts) {
    return sum(amounts) === Number('0').toFixed(2);
}
exports.sumsToZero = sumsToZero;
function decimalPlaces(amount) {
    if (Math.floor(Number(amount)) === Number(amount)) {
        return 0;
    }
    return Number(amount).toString().split('.')[1].length || 0;
}
exports.decimalPlaces = decimalPlaces;
function moneyFormatFromPositiveInteger(value) {
    if (parseFloat(String(value)) === 0) {
        return '0.00';
    }
    var parts = String(value).split('');
    if (parts.length < 2) {
        for (var i = 0; i < 2 - parts.length; i++) {
            parts.unshift('0');
        }
    }
    parts.splice(-2, 0, '.');
    if (parts[0] == '.') {
        parts.unshift('0');
    }
    return parts.join('');
}
exports.moneyFormatFromPositiveInteger = moneyFormatFromPositiveInteger;
//# sourceMappingURL=number.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/number.js
// module id = qxja
// module chunks = 0